import React, { useMemo } from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { Orientation, Variant } from '../utils/types'

interface CardImageProps {
  orientation: Orientation
  variant: Variant
}

const StyledImage = styled.div`
  ${s({
    mt: '20%',
    mb: '15%',
  })}
`
const StyledPortraitCardImage = styled(StyledImage)`
  width: 60%;
`

const StyledSquareCardImage = styled(StyledImage)`
  width: 60%;
`

const StyledLandscapeCardImage = styled(StyledImage)`
  width: 70%;
  margin-left: 10%;
`

export const CardImageWrapper: React.FC<
  React.PropsWithChildren<CardImageProps>
> = ({ children, ...props }) => {
  const { orientation } = props

  const ImageComponent = useMemo(() => {
    switch (orientation) {
      case Orientation.Landscape:
        return StyledLandscapeCardImage
      case Orientation.Square:
        return StyledSquareCardImage
      default:
        return StyledPortraitCardImage
    }
  }, [orientation])

  return <ImageComponent {...props}>{children}</ImageComponent>
}
